/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetAspectRatio } from './assetAspectRatio';


export interface ShareAssetDetails { 
    assetId: string;
    version: number;
    aspectRatios: Array<AssetAspectRatio>;
}

